import { createSlice } from "@reduxjs/toolkit";
import { getAllItemInventoryData, getAllReconcileData, getAllReportsData } from "src/thunks/reports";

const initialState = {
  loading: false,
  allReportsData: {
    DataTable: [],
    WeekInfoList: []
  },
  allinventoryData: [],
  reconcileData: [],
  reportsDataLoading: false,
  inventoryreportsDataLoading: false,
  reconcileDataLoading: false,
};

const searchSlice = createSlice({
  name: "searchSlice",
  reducers: {},
  initialState,

  extraReducers: (builder) => {
    builder

      /** Retrieve all monthly report data ---------------------- **/
      .addCase(getAllReportsData.pending, (state, action) => {
        state.reportsDataLoading = true;
      })
      .addCase(getAllReportsData.fulfilled, (state, action) => {
        state.reportsDataLoading = false;
        state.allReportsData = action.payload;
      })
      .addCase(getAllReportsData.rejected, (state, action) => {
        state.allReportsData = {
          DataTable: [],
          WeekInfoList: []
        };
        state.reportsDataLoading = false;
      })
      .addCase(getAllItemInventoryData.pending, (state, action) => {
        state.inventoryreportsDataLoading = true;
      })
      .addCase(getAllItemInventoryData.fulfilled, (state, action) => {
        state.inventoryreportsDataLoading = false;
        state.allinventoryData = action.payload;
      })
      .addCase(getAllItemInventoryData.rejected, (state, action) => {
        state.allinventoryData = [];
        state.inventoryreportsDataLoading = false;
      })
      .addCase(getAllReconcileData.pending, (state, action) => {
        state.reconcileDataLoading = true;
      })
      .addCase(getAllReconcileData.fulfilled, (state, action) => {
        state.reconcileDataLoading = false;
        state.reconcileData = action.payload;
      })
      .addCase(getAllReconcileData.rejected, (state, action) => {
        state.reconcileData = [];
        state.reconcileDataLoading = false;
      })
  },
});

export default searchSlice;
